<template>
  <div class="tab-container">
    <div class="tab-nav">
      <div class="nav-link">
        <router-link to="/map">
          <font-awesome-icon class="icon" icon="route" size="xl" />
          Maps
        </router-link>
      </div>
      <div class="nav-link">
        <router-link to="/">
          <font-awesome-icon class="icon" icon="rocket" size="xl" />
          Orders
        </router-link>
      </div>
      <!-- <div class="nav-link">
        <router-link to="/settings">
          <font-awesome-icon class="icon" icon="wrench" size="xl" />
          Settings
        </router-link>
      </div> -->
      <div class="nav-link">
        <router-link to="/login" @click="logout">
          <font-awesome-icon class="icon" icon="right-from-bracket" size="xl" />
          Logout
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationTabs",
  data() {
    return {};
  },

  methods: {
    logout() {
      window.localStorage.clear();
    },
  },
};

</script>

<style scoped lang="scss">
@use "@monolith/styles";

.tab-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: var(--secondary-colour);
  width: 100%;
  padding: 0.5rem 0;
  .nav-link {
    a {
      display: flex;
      flex-direction: column;
      text-align: center;
      padding: 0.5rem 0;
      gap: 0.25rem;
      color: var(--text-colour);
      text-decoration: none;
      font-size: 1rem;
      .icon {
        color: var(--text-colour);
      }
    }
  }
}
</style>
